import React from "react";
import ReactApexChart from "react-apexcharts";

type CreativeModalProps = {
  open: boolean;
  onClose: () => void;
  creative: any;
};

const chartData = {
  series: [
    { name: "Leads", data: [12000, 18000, 15000, 17000, 16000, 19000, 20000] },
    { name: "Clicks", data: [10000, 12000, 14000, 11000, 13000, 17000, 15000] },
    { name: "CPR", data: [7000, 9000, 8000, 10000, 9500, 10500, 11000] },
    { name: "CPC", data: [5000, 4000, 6000, 4500, 4800, 4900, 5200] },
    { name: "Hook Rate", data: [8000, 10000, 9000, 11000, 9500, 12000, 13000] },
    { name: "Hold Rate", data: [4000, 6000, 7000, 5000, 6000, 7000, 8000] },
  ],
  options: {
    chart: { type: "line", height: 350, zoom: { enabled: false } },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: ["Jan 21", "Jan 22", "Jan 23", "Jan 24", "Jan 25", "Jan 26", "Jan 27"],
    },
    legend: { position: "top" },
    colors: ["#A855F7", "#3B82F6", "#EF4444", "#F59E0B", "#EC4899", "#6366F1"],
  },
};

const CreativesDetailModal: React.FC<CreativeModalProps> = ({ open, onClose, creative }) => {
  if (!open || !creative) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-lg w-[90%] max-w-5xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">Creative Detail</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-black text-2xl">×</button>
        </div>

        {/* Video */}
        <div className="p-4">
          <div className="relative w-full h-64 rounded-lg overflow-hidden">
            <img src={creative.thumbnail} alt="Creative video" className="w-full h-full object-cover" />
            <div className="absolute inset-0 flex items-center justify-center bg-black/40">
              <button className="w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-md text-2xl">▶</button>
            </div>
          </div>
        </div>

        {/* KPI’s */}
        <div className="px-4">
          <h3 className="text-lg font-semibold mb-3">KPI’s</h3>
          <ReactApexChart options={chartData.options} series={chartData.series} type="line" height={350} />
        </div>

        {/* Campaigns & Audiences */}
        <div className="px-4 py-6">
          <h3 className="text-lg font-semibold mb-3">Active Campaigns & Audiences</h3>
          <div className="mb-4">
            <p className="font-medium mb-2">Campaigns</p>
            <div className="flex flex-wrap gap-2">
              {["Campaign 1", "Campaign 2", "Campaign 3", "Campaign 4"].map((c) => (
                <span key={c} className="px-3 py-1 bg-purple-50 text-purple-700 rounded-lg text-sm font-medium">{c}</span>
              ))}
            </div>
          </div>
          <div>
            <p className="font-medium mb-2">Audiences</p>
            <div className="flex flex-wrap gap-2">
              {["Audience 1", "Audience 2", "Audience 3", "Audience 4"].map((a) => (
                <span key={a} className="px-3 py-1 bg-purple-50 text-purple-700 rounded-lg text-sm font-medium">{a}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreativesDetailModal;
